import React from 'react'

export default props => (
    <div className='row'>{props.children}</div>
)


// WEBPACK FOOTER //
// ./src/common/layout/row.jsx